module.exports = __webpack_public_path__ + "img/info.d27542fd.svg";